import { SuppliersContextProvider } from 'Context/SuppliersContext';
import { Helmet } from 'react-helmet-async';
import { SuppliersMain } from './SuppliersMain';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';

export const Suppliers = () => {
  return (
    <SuppliersContextProvider>
      <Helmet title={Dictionary[DICTIONARY.Suppliers].title} />
      <SuppliersMain />
    </SuppliersContextProvider>
  );
};
